import { TokenManager } from './tokenManager'
import type { ApiResponse } from '@bandos/shared'

/**
 * Authentication guard that ensures user is authenticated before making API calls
 * Returns auth headers if authenticated, or an error response if not
 */
export class AuthGuard {
  /**
   * Gets authentication headers and validates that user is authenticated
   * @returns Auth headers if valid, or error response object if not authenticated
   */
  static async getAuthHeadersOrError(): Promise<
    | { headers: Record<string, string>; error: undefined }
    | { headers: undefined; error: ApiResponse<never>['error'] }
  > {
    const headers = await TokenManager.getAuthHeaders()

    if (!headers.Authorization) {
      return {
        headers: undefined,
        error: {
          message: 'Authentication required. Please log in.',
          code: 'AUTH_REQUIRED',
        },
      }
    }

    return { headers, error: undefined }
  }
}
